import type { PropsWithChildren } from "react";
import styles from "./TagsContainer.module.css";

export const TagsContainer = ({ children }: PropsWithChildren) => {
	return <div className={styles["tags-container"]}>{children}</div>;
};
